// Mock data for Learndunia - Edtech Portal

export const CATEGORIES = [
  { key: 'colleges', label: 'Colleges', icon: 'Building2', count: '35,000+' },
  { key: 'universities', label: 'Universities', icon: 'GraduationCap', count: '1,200+' },
  { key: 'courses', label: 'Courses', icon: 'BookOpen', count: '15,000+' },
  { key: 'exams', label: 'Exams', icon: 'ClipboardList', count: '250+' },
  { key: 'scholarships', label: 'Scholarships', icon: 'Award', count: '800+' },
  { key: 'blogs', label: 'Blogs', icon: 'Newspaper', count: '5,000+' },
];

export const STREAMS = [
  { key: 'engineering', label: 'Engineering', icon: 'Cog', color: 'bg-teal-50 text-teal-700' },
  { key: 'management', label: 'Management', icon: 'Briefcase', color: 'bg-orange-50 text-orange-700' },
  { key: 'medical', label: 'Medical', icon: 'Stethoscope', color: 'bg-rose-50 text-rose-700' },
  { key: 'law', label: 'Law', icon: 'Scale', color: 'bg-indigo-50 text-indigo-700' },
  { key: 'design', label: 'Design', icon: 'Palette', color: 'bg-fuchsia-50 text-fuchsia-700' },
  { key: 'arts', label: 'Arts', icon: 'Music2', color: 'bg-amber-50 text-amber-700' },
  { key: 'science', label: 'Science', icon: 'Atom', color: 'bg-emerald-50 text-emerald-700' },
  { key: 'commerce', label: 'Commerce', icon: 'TrendingUp', color: 'bg-sky-50 text-sky-700' },
];

export const COLLEGES = [
  {
    id: 'iit-bombay',
    name: 'Indian Institute of Technology, Bombay',
    short: 'IIT Bombay',
    location: 'Powai, Mumbai, Maharashtra',
    city: 'Mumbai',
    state: 'Maharashtra',
    established: 1958,
    type: 'Public',
    accreditation: 'NAAC A++',
    ranking: 1,
    rating: 4.8,
    reviews: 1284,
    fees: '₹2.28 Lakhs / Year',
    image: 'https://images.unsplash.com/photo-1562774053-701939374585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjb2xsZWdlJTIwY2FtcHVzfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85',
    logo: 'https://ui-avatars.com/api/?name=IIT+B&background=0D9488&color=fff&bold=true',
    streams: ['engineering', 'science'],
    courses: ['B.Tech', 'M.Tech', 'PhD', 'MBA'],
    highlights: ['NIRF Rank #3', '95% placement', '₹21.8 LPA avg package'],
    about: 'IIT Bombay is one of Indias premier engineering institutions with world-class faculty and research infrastructure.',
  },
  {
    id: 'iim-ahmedabad',
    name: 'Indian Institute of Management, Ahmedabad',
    short: 'IIM Ahmedabad',
    location: 'Vastrapur, Ahmedabad, Gujarat',
    city: 'Ahmedabad',
    state: 'Gujarat',
    established: 1961,
    type: 'Public',
    accreditation: 'AACSB, EQUIS',
    ranking: 2,
    rating: 4.9,
    reviews: 942,
    fees: '₹23 Lakhs / Year',
    image: 'https://images.pexels.com/photos/33639865/pexels-photo-33639865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    logo: 'https://ui-avatars.com/api/?name=IIM+A&background=F97316&color=fff&bold=true',
    streams: ['management'],
    courses: ['PGP', 'PGPX', 'FPM', 'Executive MBA'],
    highlights: ['Top B-School in India', '100% placement', '₹34.5 LPA avg package'],
    about: 'IIM Ahmedabad is Indias top-ranked business school known for its rigorous case-based pedagogy.',
  },
  {
    id: 'aiims-delhi',
    name: 'All India Institute of Medical Sciences, Delhi',
    short: 'AIIMS Delhi',
    location: 'Ansari Nagar, New Delhi',
    city: 'New Delhi',
    state: 'Delhi',
    established: 1956,
    type: 'Public',
    accreditation: 'NAAC A+',
    ranking: 3,
    rating: 4.7,
    reviews: 1620,
    fees: '₹1,628 / Year',
    image: 'https://images.unsplash.com/photo-1583373834259-46cc92173cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHx1bml2ZXJzaXR5JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85',
    logo: 'https://ui-avatars.com/api/?name=AIIMS&background=E11D48&color=fff&bold=true',
    streams: ['medical'],
    courses: ['MBBS', 'MD', 'MS', 'B.Sc Nursing'],
    highlights: ['Top Medical College', 'Highly subsidized fees', 'World-class research'],
    about: 'AIIMS Delhi is Indias most reputed medical institute for teaching, research, and patient care.',
  },
  {
    id: 'nlsiu-bangalore',
    name: 'National Law School of India University',
    short: 'NLSIU Bangalore',
    location: 'Nagarbhavi, Bengaluru, Karnataka',
    city: 'Bengaluru',
    state: 'Karnataka',
    established: 1987,
    type: 'Public',
    accreditation: 'NAAC A',
    ranking: 4,
    rating: 4.6,
    reviews: 512,
    fees: '₹2.75 Lakhs / Year',
    image: 'https://images.pexels.com/photos/19014974/pexels-photo-19014974.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    logo: 'https://ui-avatars.com/api/?name=NLS&background=4F46E5&color=fff&bold=true',
    streams: ['law'],
    courses: ['B.A. LLB', 'LLM', 'PhD'],
    highlights: ['#1 Law School', 'Excellent moot court', 'Top recruiter footprint'],
    about: 'NLSIU is a pioneer of legal education in India offering a rigorous 5-year integrated LLB.',
  },
  {
    id: 'nid-ahmedabad',
    name: 'National Institute of Design',
    short: 'NID Ahmedabad',
    location: 'Paldi, Ahmedabad, Gujarat',
    city: 'Ahmedabad',
    state: 'Gujarat',
    established: 1961,
    type: 'Autonomous',
    accreditation: 'Govt. of India',
    ranking: 5,
    rating: 4.5,
    reviews: 380,
    fees: '₹3.85 Lakhs / Year',
    image: 'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxjb2xsZWdlJTIwY2FtcHVzfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85',
    logo: 'https://ui-avatars.com/api/?name=NID&background=DB2777&color=fff&bold=true',
    streams: ['design', 'arts'],
    courses: ['B.Des', 'M.Des', 'PhD Design'],
    highlights: ['Top design school', 'International tie-ups', 'Studio-based learning'],
    about: 'NID is a globally acclaimed institute for design education blending craft, technology and business.',
  },
  {
    id: 'du-delhi',
    name: 'University of Delhi',
    short: 'Delhi University',
    location: 'North Campus, Delhi',
    city: 'New Delhi',
    state: 'Delhi',
    established: 1922,
    type: 'Central University',
    accreditation: 'NAAC A+',
    ranking: 6,
    rating: 4.4,
    reviews: 2450,
    fees: '₹18,000 / Year',
    image: 'https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxjb2xsZWdlJTIwY2FtcHVzfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85',
    logo: 'https://ui-avatars.com/api/?name=DU&background=0EA5E9&color=fff&bold=true',
    streams: ['arts', 'commerce', 'science'],
    courses: ['B.A.', 'B.Com', 'B.Sc', 'M.A.', 'MBA'],
    highlights: ['Over 80 colleges', 'Diverse programs', 'Vibrant campus life'],
    about: 'The University of Delhi is one of the largest and most respected universities in India.',
  },
  {
    id: 'bits-pilani',
    name: 'Birla Institute of Technology and Science',
    short: 'BITS Pilani',
    location: 'Pilani, Rajasthan',
    city: 'Pilani',
    state: 'Rajasthan',
    established: 1964,
    type: 'Private (Deemed)',
    accreditation: 'NAAC A',
    ranking: 7,
    rating: 4.6,
    reviews: 890,
    fees: '₹5.41 Lakhs / Year',
    image: 'https://images.pexels.com/photos/7972324/pexels-photo-7972324.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    logo: 'https://ui-avatars.com/api/?name=BITS&background=059669&color=fff&bold=true',
    streams: ['engineering', 'science'],
    courses: ['B.E.', 'M.E.', 'MBA', 'PhD'],
    highlights: ['Merit-based BITSAT admission', 'Practice School program', 'Global alumni'],
    about: 'BITS Pilani is a leading private technology institute known for its academic freedom and industry linkages.',
  },
  {
    id: 'srcc-delhi',
    name: 'Shri Ram College of Commerce',
    short: 'SRCC',
    location: 'Maurice Nagar, Delhi',
    city: 'New Delhi',
    state: 'Delhi',
    established: 1926,
    type: 'Public',
    accreditation: 'NAAC A+',
    ranking: 8,
    rating: 4.7,
    reviews: 720,
    fees: '₹32,000 / Year',
    image: 'https://images.unsplash.com/20/cambridge.JPG?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85',
    logo: 'https://ui-avatars.com/api/?name=SRCC&background=CA8A04&color=fff&bold=true',
    streams: ['commerce'],
    courses: ['B.Com (H)', 'B.A. Economics (H)', 'MBA'],
    highlights: ['#1 Commerce college', 'Top CA/CS/CFA feeder', 'Excellent placements'],
    about: 'SRCC is Indias premier college for commerce and economics with rigorous curriculum.',
  },
];

export const UNIVERSITIES = [
  { id: 'ju', name: 'Jadavpur University', location: 'Kolkata, West Bengal', type: 'State', naac: 'A+', established: 1955, image: 'https://images.pexels.com/photos/19014974/pexels-photo-19014974.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', courses: 120, rating: 4.5 },
  { id: 'jnu', name: 'Jawaharlal Nehru University', location: 'New Delhi', type: 'Central', naac: 'A++', established: 1969, image: 'https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxjb2xsZWdlJTIwY2FtcHVzfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85', courses: 180, rating: 4.6 },
  { id: 'bhu', name: 'Banaras Hindu University', location: 'Varanasi, UP', type: 'Central', naac: 'A+', established: 1916, image: 'https://images.unsplash.com/20/cambridge.JPG?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85', courses: 220, rating: 4.4 },
  { id: 'mu', name: 'University of Mumbai', location: 'Mumbai, Maharashtra', type: 'State', naac: 'A', established: 1857, image: 'https://images.pexels.com/photos/33639865/pexels-photo-33639865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', courses: 350, rating: 4.2 },
  { id: 'anna', name: 'Anna University', location: 'Chennai, Tamil Nadu', type: 'State', naac: 'A+', established: 1978, image: 'https://images.unsplash.com/photo-1583373834259-46cc92173cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHx1bml2ZXJzaXR5JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85', courses: 200, rating: 4.5 },
  { id: 'du2', name: 'University of Hyderabad', location: 'Hyderabad, Telangana', type: 'Central', naac: 'A++', established: 1974, image: 'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxjb2xsZWdlJTIwY2FtcHVzfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85', courses: 150, rating: 4.4 },
];

export const EXAMS = [
  { id: 'jee-main', name: 'JEE Main', full: 'Joint Entrance Examination (Main)', stream: 'engineering', level: 'National', mode: 'Online', frequency: 'Twice a Year', nextDate: '25 Jan 2025', registrations: '12L+', image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxzdHVkZW50cyUyMHN0dWR5aW5nfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85', description: 'JEE Main is the gateway to NITs, IIITs and other centrally funded technical institutions.' },
  { id: 'neet', name: 'NEET UG', full: 'National Eligibility cum Entrance Test', stream: 'medical', level: 'National', mode: 'Pen-Paper', frequency: 'Once a Year', nextDate: '05 May 2025', registrations: '20L+', image: 'https://images.pexels.com/photos/7092523/pexels-photo-7092523.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', description: 'NEET is the single entrance exam for MBBS and BDS admissions across India.' },
  { id: 'cat', name: 'CAT', full: 'Common Admission Test', stream: 'management', level: 'National', mode: 'Online', frequency: 'Once a Year', nextDate: '30 Nov 2025', registrations: '3L+', image: 'https://images.pexels.com/photos/37811262/pexels-photo-37811262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', description: 'CAT is the entrance exam for IIMs and top B-Schools in India.' },
  { id: 'clat', name: 'CLAT', full: 'Common Law Admission Test', stream: 'law', level: 'National', mode: 'Offline', frequency: 'Once a Year', nextDate: '01 Dec 2024', registrations: '75K+', image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxzdHVkZW50cyUyMHN0dWR5aW5nfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85', description: 'CLAT is a centralized entrance test for admissions to 24 National Law Universities.' },
  { id: 'gate', name: 'GATE', full: 'Graduate Aptitude Test in Engineering', stream: 'engineering', level: 'National', mode: 'Online', frequency: 'Once a Year', nextDate: '01 Feb 2025', registrations: '9L+', image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxzdHVkZW50cyUyMHN0dWR5aW5nfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85', description: 'GATE tests engineering knowledge for M.Tech admissions and PSU recruitments.' },
  { id: 'nid-dat', name: 'NID DAT', full: 'NID Design Aptitude Test', stream: 'design', level: 'National', mode: 'Offline', frequency: 'Once a Year', nextDate: '05 Jan 2025', registrations: '25K+', image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxzdHVkZW50cyUyMHN0dWR5aW5nfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85', description: 'DAT is the entrance test for NID and other top design institutes.' },
];

export const COURSES = [
  { id: 'btech', name: 'B.Tech', full: 'Bachelor of Technology', duration: '4 Years', stream: 'engineering', avgFees: '₹1L – ₹5L / year', avgSalary: '₹6-25 LPA', colleges: 6500, description: 'Undergraduate engineering degree across specializations like CSE, ECE, ME.' },
  { id: 'mba', name: 'MBA', full: 'Master of Business Administration', duration: '2 Years', stream: 'management', avgFees: '₹2L – ₹25L / total', avgSalary: '₹8-34 LPA', colleges: 3200, description: 'Postgraduate management degree with specializations in Finance, Marketing, HR & more.' },
  { id: 'mbbs', name: 'MBBS', full: 'Bachelor of Medicine, Bachelor of Surgery', duration: '5.5 Years', stream: 'medical', avgFees: '₹10K – ₹22L / year', avgSalary: '₹6-18 LPA', colleges: 705, description: 'Undergraduate medical degree for practising as a doctor.' },
  { id: 'bcom', name: 'B.Com', full: 'Bachelor of Commerce', duration: '3 Years', stream: 'commerce', avgFees: '₹10K – ₹1L / year', avgSalary: '₹3-8 LPA', colleges: 5400, description: 'Undergraduate degree in commerce, accounting and finance.' },
  { id: 'bdes', name: 'B.Des', full: 'Bachelor of Design', duration: '4 Years', stream: 'design', avgFees: '₹1.5L – ₹4L / year', avgSalary: '₹4-15 LPA', colleges: 380, description: 'Undergraduate design program across product, communication and fashion.' },
  { id: 'llb', name: 'LLB', full: 'Bachelor of Laws', duration: '3 Years', stream: 'law', avgFees: '₹20K – ₹3L / year', avgSalary: '₹4-12 LPA', colleges: 1200, description: 'Postgraduate legal degree for law practice and litigation.' },
];

export const BLOGS = [
  { id: 'jee-2025-tips', title: 'JEE Main 2025: Last 30 Days Preparation Strategy', excerpt: 'A day-by-day plan to maximize your score in JEE Main - focus areas, mock strategy and stress management.', author: 'Aditi Sharma', date: 'Dec 20, 2024', category: 'Exam Prep', readTime: '8 min', image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxzdHVkZW50cyUyMHN0dWR5aW5nfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85' },
  { id: 'top-mba-2025', title: 'Top 10 MBA Colleges in India for 2025', excerpt: 'The updated ranking of Indias best B-schools based on placements, faculty and academic rigor.', author: 'Rahul Verma', date: 'Dec 18, 2024', category: 'College Guide', readTime: '12 min', image: 'https://images.pexels.com/photos/33639865/pexels-photo-33639865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 'nirf-2025', title: 'NIRF Rankings 2025: What Changed This Year', excerpt: 'Deep dive into the NIRF methodology updates and the biggest movers in this years rankings.', author: 'Priya Nair', date: 'Dec 15, 2024', category: 'News', readTime: '6 min', image: 'https://images.unsplash.com/photo-1583373834259-46cc92173cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHx1bml2ZXJzaXR5JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85' },
  { id: 'design-career', title: 'Is a Career in Design Right for You?', excerpt: 'Explore design specializations, industry demand and how to build a portfolio that stands out.', author: 'Neha Kapoor', date: 'Dec 12, 2024', category: 'Career', readTime: '9 min', image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxzdHVkZW50cyUyMHN0dWR5aW5nfGVufDB8fHx8MTc4MzkzNzAxN3ww&ixlib=rb-4.1.0&q=85' },
  { id: 'scholarship-guide', title: 'Complete Guide to Scholarships for Indian Students 2025', excerpt: 'Government, private and international scholarships every student should know about.', author: 'Vikram Singh', date: 'Dec 10, 2024', category: 'Scholarships', readTime: '15 min', image: 'https://images.pexels.com/photos/7092523/pexels-photo-7092523.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 'study-abroad', title: 'Study Abroad vs Study in India: 2025 Comparison', excerpt: 'Cost, ROI, career outcomes - a balanced look at studying overseas versus at home.', author: 'Sneha Rao', date: 'Dec 05, 2024', category: 'Guide', readTime: '11 min', image: 'https://images.pexels.com/photos/37811262/pexels-photo-37811262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
];

export const TESTIMONIALS = [
  { name: 'Ananya Iyer', role: 'B.Tech Student, IIT Madras', avatar: 'https://images.unsplash.com/photo-1607013407627-6ee814329547?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxncmFkdWF0aW9uJTIwc3R1ZGVudHN8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85', quote: 'Learndunia helped me compare 20+ engineering colleges and make an informed decision. The rankings and reviews are super detailed.', rating: 5 },
  { name: 'Karan Malhotra', role: 'MBA Aspirant', avatar: 'https://images.unsplash.com/photo-1525921429624-479b6a26d84d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxncmFkdWF0aW9uJTIwc3R1ZGVudHN8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85', quote: 'The CAT exam page has every detail I needed - eligibility, pattern, previous cutoffs. Saved me weeks of research.', rating: 5 },
  { name: 'Dr. Meera Bhatt', role: 'MBBS Graduate, AIIMS', avatar: 'https://images.pexels.com/photos/36622165/pexels-photo-36622165.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', quote: 'From NEET counselling to college selection, Learndunia\u2019s guidance was invaluable throughout my medical journey.', rating: 5 },
  { name: 'Rohan Deshmukh', role: 'B.Des Student, NID', avatar: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxncmFkdWF0aW9uJTIwc3R1ZGVudHN8ZW58MHx8fHwxNzgzOTM3MDE3fDA&ixlib=rb-4.1.0&q=85', quote: 'The design career blog inspired me to pursue B.Des. The college comparison tool sealed the deal.', rating: 4 },
];

export const CITIES = [
  { name: 'Delhi NCR', colleges: 2400 },
  { name: 'Mumbai', colleges: 1850 },
  { name: 'Bengaluru', colleges: 1720 },
  { name: 'Chennai', colleges: 1520 },
  { name: 'Hyderabad', colleges: 1420 },
  { name: 'Pune', colleges: 1380 },
  { name: 'Kolkata', colleges: 1240 },
  { name: 'Ahmedabad', colleges: 980 },
];

export const STATS = [
  { label: 'Colleges Listed', value: '35,000+' },
  { label: 'Verified Reviews', value: '2.4L+' },
  { label: 'Students Helped', value: '18L+' },
  { label: 'Expert Counsellors', value: '500+' },
];
